import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalModalService {
  private readonly STORAGE_KEY = 'globalModalEnabled';
  private readonly LAST_AUTO_OPEN_KEY = 'globalModalLastAutoOpen';
  private readonly REMIND_LATER_KEY = 'globalModalRemindLater';
  private readonly DAYS_INTERVAL = 3; // Días entre aperturas automáticas
  private modalVisible$ = new BehaviorSubject<boolean>(false);
  private mfaActivated$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.checkLocalStorage();
    this.interceptLocalStorageClear();
  }

  private interceptLocalStorageClear(): void {
    const originalClear = localStorage.clear.bind(localStorage);
    localStorage.clear = () => {
      const remindLaterValue = localStorage.getItem(this.REMIND_LATER_KEY);
      originalClear();
      if (remindLaterValue) {
        localStorage.setItem(this.REMIND_LATER_KEY, remindLaterValue);
      }
    };
  }

  private checkLocalStorage(): void {
    const storedValue = localStorage.getItem(this.STORAGE_KEY);
    const isEnabled = storedValue === 'true';
    this.modalVisible$.next(isEnabled);
  }

  getModalVisibility(): Observable<boolean> {
    return this.modalVisible$.asObservable();
  }

  isModalVisible(): boolean {
    return this.modalVisible$.value;
  }

  enableModal(): void {
    localStorage.setItem(this.STORAGE_KEY, 'true');
    this.modalVisible$.next(true);
  }

  disableModal(): void {
    localStorage.setItem(this.STORAGE_KEY, 'false');
    this.modalVisible$.next(false);
  }

  toggleModal(): void {
    if (this.isModalVisible()) {
      this.disableModal();
    } else {
      this.enableModal();
    }
  }

  closeModal(): void {
    this.modalVisible$.next(false);
  }

  openModal(): void {
    this.modalVisible$.next(true);
  }

  saveLastAutoOpenDate(): void {
    const now = new Date().toISOString();
    localStorage.setItem(this.LAST_AUTO_OPEN_KEY, now);
  }

  getLastAutoOpenDate(): Date | null {
    const storedDate = localStorage.getItem(this.LAST_AUTO_OPEN_KEY);
    if (!storedDate) {
      return null;
    }
    return new Date(storedDate);
  }

  shouldAutoOpen(): boolean {
    const lastOpenDate = this.getLastAutoOpenDate();
    
    if (!lastOpenDate) {
     
      return true;
    }

    const now = new Date();
    const diffTime = now.getTime() - lastOpenDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays >= this.DAYS_INTERVAL;
  }

  autoOpenModal(): void {
    this.openModal();
  }

  notifyMfaActivated(): void {
    this.mfaActivated$.next(true);
  }

  getMfaActivated(): Observable<boolean> {
    return this.mfaActivated$.asObservable();
  }

  resetMfaActivated(): void {
    this.mfaActivated$.next(false);
  }

  saveRemindLater(): void {
    const now = new Date().toISOString();
    localStorage.setItem(this.REMIND_LATER_KEY, now);
  }

  getRemindLaterDate(): Date | null {
    const storedDate = localStorage.getItem(this.REMIND_LATER_KEY);
    if (!storedDate) {
      return null;
    }
    return new Date(storedDate);
  }

  shouldShowAfterRemindLater(): boolean {
    const remindLaterDate = this.getRemindLaterDate();
    
    if (!remindLaterDate) {
   
      return true;
    }

    const now = new Date();
    const diffTime = now.getTime() - remindLaterDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays >= this.DAYS_INTERVAL;
  }
}

